import UAParser from "ua-parser-js";

export const isInlineVideoSupported = (deviceInfo: UAParser.IResult) => {
    if (deviceInfo?.browser?.name === "Safari" || deviceInfo?.os?.name === "iOS") {
        const browserVersion = parseInt(deviceInfo?.browser?.version);
        if (!isNaN(browserVersion)) {
            return browserVersion !== 14;
        }
        return false;
    } else {
        return true;
    }
};

const iOSversion = () => {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
        try {
            const v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || "0", 10)];
        } catch (error) {
            console.log(`Error parsing appVersion. Falling back to -1. Error: ${error}`);
            return [-1];
        }
    }
    return [-1];
};

const checkIOSVersion = () => {
    return iOSversion()[0] >= 13;
};


export const isIOS = () => {
    return ((/iPad|iPhone|iPod/.test(navigator.platform) && checkIOSVersion()) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
};

const isiOS163OrLess = () => {
    const ver = iOSversion();
    return ver && ver[0] != -1 && ver.length >= 1 && ver[0] == 16 && ver[1] < 4;
};

export const isDeviceAffectedByIOS16Issue = () => {
    const decodedCookie = decodeURIComponent(document.cookie);
    if (decodedCookie.includes('AcuantForceRegularCapture=true')) {
        return false;
    }
    if (decodedCookie.includes('AcuantForceDistantCapture=true')) {
        return true;
    }
    if (isiOS163OrLess()) {
        const dims = [screen.width, screen.height];
        const long = Math.max(...dims);
        const short = Math.min(...dims);
        if (long == 852 && short == 393) { //14 pro
            return true;
        }
        if (long == 932 && short == 430) { //14 pro max
            return true;
        }
        if (long == 844 && short == 390) { //13 pro
            return true;
        }
        if (long == 926 && short == 428) { //13 pro max
            return true;
        }
    }
    return false;
}